import $ from 'jquery';

const mobile = {
	breakpoint: 993,  // seuil normal-screen SCSS pour être considéré "mobile"
	state: false,     // sera mis à jour dynamiquement

	check() {
		this.state = window.innerWidth < this.breakpoint;
	},

	init() {
		// Vérifie au démarrage
		this.check();

		// Met à jour à chaque resize
		window.addEventListener('resize', () => {
			this.check();
		});

		$(document).on("click", "._basket", function () {
			const $panel = $(".__module_basket");
			const willShow = !$panel.is(":visible");

			if (willShow) {
				mobile.closeMobileMenu();
			}

			$panel.toggle(willShow);
			$("._basket_backdrop").toggleClass("_show", willShow);
		});

		$(document).on("click", "._close_basket, ._basket_backdrop", function () {
			$(".__module_basket").hide();
			$("._basket_backdrop").removeClass("_show");
		});
	},

	// Utilise par le panier (ci-dessus) pour fermer le menu hamburger s'il
	// est ouvert - reproduit juste le sous-ensemble "fermeture" de
	// utils/menu.js#toggleMENU plutot que d'importer ce module (menu.js
	// importe deja mobile.js, un import inverse creerait un cycle).
	closeMobileMenu() {
		const container = $("._contain_ss_menus");
		if (container.hasClass("_open")) {
			container.removeClass("_open").addClass("_close");
			$(".__header").removeClass("_open_mobile");
			$(".ham").removeClass("active");
			$("html,body").removeClass("_overflow");
		}
	},

	// Utilise par utils/menu.js#toggleMENU pour fermer le panier a
	// l'ouverture du menu (sens inverse, sans probleme de cycle puisque
	// menu.js importe deja mobile.js).
	closeBasket() {
		$(".__module_basket").hide();
		$("._basket_backdrop").removeClass("_show");
	},

	// Utilise par le bottom sheet de reservation (product_booking_sheet.js)
	// et par l'assistant IA pour garder un seul panneau flottant ouvert a la
	// fois, meme principe que closeMobileMenu()/closeBasket() ci-dessus.
	closeBookingSheet() {
		$("#ophorus_booking_sheet").removeClass("_open").attr("aria-hidden", "true");
		$(".__booking_sheet_backdrop").removeClass("_show");
		$("html,body").removeClass("_overflow");
	}
};

export default mobile;
